import React from "react";
import { Edit } from "react-admin";

export default props => {
  return <Edit undoable={false} {...props} />;
};
